import React from "react";
import HomeIcon from "../common/HomeIcon";
import { userDetailStore, listApiStore } from "../../config/store";
import Mantra_11_A1_Canvas from "./Mantra_11_A1_Canvas";
import { Html2CanvasFunction } from "../../utils/NewHelper";
import $ from "jquery";
import WallList from "../common/WallList";
import Mantra_11_A1_Posted from "./Mantra_11_A1_Posted";
import Loader from "../loader/loader";
import { onImageFileUploaded } from "../../utils/helper";
import { showCongratulations } from "../../utils/misc";

class Mantra_11_A1 extends React.Component {
  constructor() {
    super();
    this.state = {
      btn: "Rest well",
      showposted: false,
      isLoading: false,
      name:
        userDetailStore.getState().userDetail &&
        userDetailStore.getState().userDetail["user_name_display"],
      message: null,
      defaultName:
        userDetailStore.getState().userDetail &&
        userDetailStore.getState().userDetail["user_name_display"],
    };
  }

  share = async () => {

    if (this.name.value && this.message.value && this.state.btn) {
      this.setState({
        isLoading: true,
      });
      //canvas this means canvas is all set, read the name and festival and generate canvas now
      $(".preloader_mantra").show();
      var ref = this;
      let reqdata = {
        type: ref.props.type,
        module_name: ref.props.module_name,
      };
      let resData = await Html2CanvasFunction(reqdata);
      resData.addEventListener("load", function (data) {
        data = resData.response;
        data = JSON.parse(data);
        var imageUrl = data.data.cardimage;
        var id = data.data.id;
        // ref.message.value = ''
        ref.setState({
          shareData: imageUrl,
          id: id,
          image: imageUrl,
          showposted: true,
          isLoading: false,
        }, () => {
          showCongratulations(ref.props.module_name)
        });
        listApiStore.dispatch({ type: "GET_LIST", data: true });
        // ref.processShare(data, params, ref);
        onImageFileUploaded({
          image: imageUrl,
          module: ref.props.module_name,
          postid: id
        });
      });
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isLoading: false,
      });
      alert("All fields are required");
    }
  };

  setBtn = (str) => {
    this.setState({ btn: str });
  };
  render() {
    const { defaultName, btn, isLoading, showposted } = this.state;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <>
        {/* <Carousel /> */}
        {!showposted && (
          <>
            <HomeIcon />
            <div className="m11_a1_container">
              <div className="container">
                <div className="m3_sh_img_prev1">
                  <span>I like to</span>
                </div>
                <div className="">
                  <img
                    src="/assets/img/Mantra_11.png"
                    className="mantra11_banner"
                  />
                  <div className="mantra_11_btns">
                    <button
                      className={btn == "Rest well" ? "btn_f" : "btn_f active"}
                      onClick={() => {
                        this.setBtn("Rest well");
                      }}
                    >
                      Rest well
                    </button>
                    <h5 className="or2">Or</h5>
                    <button
                      className={btn == "Stay Up" ? "btn_f" : "btn_f active"}
                      onClick={() => {
                        this.setBtn("Stay Up");
                      }}
                    >
                      Stay Up
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <section className="container mt30">
              <div className="m3_form_group">
                <label className="m3_label">Because...*</label>
                <textarea
                  className="m11_textarea"
                  type="text"
                  onChange={(e) => {
                    this.setState({ message: e.target.value });
                  }}
                  ref={(message) => {
                    this.message = message;
                  }}
                  placeholder="Share your reason here"
                ></textarea>
              </div>
              <div className="m3_form_group">
                <label className="m3_label">Name *</label>
                <input
                  className="m3_input"
                  onChange={(e) => {
                    this.setState({ name: e.target.value });
                  }}
                  ref={(name) => {
                    this.name = name;
                  }}
                  defaultValue={defaultName}
                  type="text"
                />
              </div>

              <div className="pos_rel">
                <img src="/assets/img/img25_1.jpg" className="img-fluid" alt="" />
                <div className="share_btn_position2">
                  <button
                    className="btn_sh"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={() => {
                      this.share();
                    }}
                  >
                    Share
                </button>
                </div>
              </div>
              {/* <div className="btn_center">
                <button
                  className="btn_sh"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  onClick={() => {
                    this.share();
                  }}
                >
                  Share
                </button>
              </div> */}
            </section>
            <WallList {...this.props} />
          </>
        )}
        {/* <section className="">
                    <div className="ex_tabs_wrp2">
                        <h4 className="ex_tabs active">Most Liked</h4>
                        <h4 className="ex_tabs">Most Recent</h4>
                        <h4 className="ex_tabs">Show All Post</h4>
                    </div>

                    <div className="m11_card_section">
                        <div className="container">
                            <div className="m11_cards_wrp mt10 mb10">
                                <div className="m3_sh_img_prev1">
                                    <span>I like to</span>
                                </div>
                                <h5 className="m11_rest_txt mt10 mb10">Rest Well</h5>
                                <img src="/assets/img/m11_img.png" className="m11_img_card" />
                                <h5 className="m11_c_txt1 mt10">Harish Singh Rautela</h5>
                                <h6 className="m11_c_txt2 mt10"><img src="/assets/img/like.png" className="m11_like" />1122</h6>

                            </div>
                            <div className="m11_cards_wrp mt10 mb10">
                                <div className="m3_sh_img_prev1">
                                    <span>I like to</span>
                                </div>
                                <h5 className="m11_rest_txt mt10 mb10">Rest Well</h5>
                                <img src="/assets/img/m11_img.png" className="m11_img_card" />
                                <h5 className="m11_c_txt1 mt10">Harish Singh Rautela</h5>
                                <h6 className="m11_c_txt2 mt10"><img src="/assets/img/like.png" className="m11_like" />1122</h6>

                            </div>
                        </div>
                    </div>
                </section>
                { */}
        {showposted && (
          <Mantra_11_A1_Posted
            img={this.state.image}
            id={this.state.id}
            message={this.state.message}
            pageData={this.props.pageData}
          />
        )}
        {this.state.name && this.state.btn && this.state.message && (
          <Mantra_11_A1_Canvas
            module_name={this.props.module_name}
            name={this.state.name}
            btn={this.state.btn}
            message={this.state.message}
            image={this.state.image}
            id={this.state.id}
          />
        )}
      </>
    );
  }
}

export default Mantra_11_A1;
